import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlight' | 'plain';
}
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const variants = {
    default: 'bg-white border border-gray-100 shadow-sm',
    highlight: 'bg-[#F5F2EA] border border-[#4A6741]/10',
    plain: 'bg-transparent border-none shadow-none'
  };
  return <div className={`rounded-xl overflow-hidden ${variants[variant]} ${className}`} data-id="element-308">
      {children}
    </div>;
}